import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

import "./styles.less";

export const SolutionSceneValue = (props) => {
  const { t } = useTranslation();

  const { value } = props;
  return (
    <>
      <div className="solution-scene-value">
        <div className="content-warp">
          <Title title={t("solution.scene.title-value")} align="left"></Title>
          <div className="descript">{value}</div>
        </div>
      </div>
    </>
  );
};
